import react from "react";
import ManualScreen from "../../screens/Manual/ManualScreen.jsx";

const ManualContainer = () => {
  return <ManualScreen />;
};

export default ManualContainer;
